<template>
  <div class="grid grid-cols-2 gap-8 md:gap-0 h-full">
    <main class="col-span-2 md:col-span-1">
      <div class="py-8 mx-auto px-4 lg:px-12 h-full flex flex-col justify-center">
        <SignInForm />
      </div>
    </main>

    <aside class="col-span-2 md:col-span-1 bg-teal-50">
      <div class="py-8 mx-auto px-4 lg:px-12 h-full flex flex-col justify-center max-w-[640px]">
        <div>
          <img src="@/images/pages/auth_top.png" alt="Register to piceditor.io" class="w-2/3 mx-auto" />
          <h2 class="hidden">{{ welcomeTexts[0] }}</h2>
          <div
            class="mt-12 font-extrabold text-transparent text-3xl bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600"
          >
            {{ welcomeText }}
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script setup lang="ts">
  import SignInForm from '&/auth/SignInForm.vue'

  const welcomeTexts = [
    'Sign In to Access Advanced Photo Editing Tools',
    'Welcome back to piceditor.io - where creativity meets technology!',
    'Ready to continue your photo editing journey? Sign in to piceditor.io!',
    'Sign in now and keep transforming your photos with ease!',
    'Your creative toolkit awaits at piceditor.io - Sign in to continue!',
    'Return to your world of advanced photo editing - Sign in now!',
    'Dive back into your projects with piceditor.io - Sign in here!',
    'Sign in to access your dashboard and start editing!',
    'Continue enhancing your photos - Sign in to piceditor.io now!',
    'Get back to creating stunning visuals - Sign in and start editing!',
    'Your images deserve the best edits - Sign in to piceditor.io to continue your work!',
  ]
  const welcomeText = welcomeTexts[Math.floor(Math.random() * welcomeTexts.length)]
</script>
